import React from "react";


/**
 * Firestore'da alan yoksa – ; gerçek 0 ise 0.
 */
export function MissingOrNumberPreview({ value }: { value?: number | null }) {
    if (value === undefined || value === null) {
        return <span>–</span>;
    }
    return <span>{value}</span>;
}
